import { Navigate } from "react-router-dom";
import { useIsAuthenticated, useAuth } from "../hooks/useAuth";
import { LoginForm } from "../components/auth/LoginForm";

export function Login() {
  const isAuthenticated = useIsAuthenticated();
  const { loading } = useAuth();

  if (loading) return null;
  if (isAuthenticated) return <Navigate to="/dashboard" replace />;

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <LoginForm />
    </div>
  );
}
